<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Centro de Diagnóstico</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <unicom-coluna sm="3" :class="espacamentoMobile">
      <Multiselect
        v-model="payload.tipoServicoEspecialidade"
        :propsMultiselect="{
          placeholder: 'Conjunto de Exames',
          options: listaExames,
          'track-by': 'id',
          label: 'tipoServicoEspecialidade'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="outrosOpcao && clickSwitch"
    >
      <div align="right" style="font-size: 15px; padding-top: 8px">
        Outros:
      </div>
    </unicom-coluna>
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <unicom-campo-texto
        ladoIcone="direito"
        :maxCaracteres="1500"
        clickIcone
        colorPlaceholder="#9E9E9E"
        placeholder="Outros Exames"
        v-model="payload.outro"
        v-if="outrosOpcao && clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="!(outrosOpcao && clickSwitch)"
    >
    </unicom-coluna>

    <unicom-coluna sm="3" :class="espacamentoMobile">
      <single-select
        @input="atualizarServicoPublico"
        :propsSingleSelect="{
          placeholder: 'Público',
          options: listaPublicoAlvo,
          'track-by': 'id',
          label: 'tipoServicoPublico'
        }"
        :value="payload.tipoServicoPublico"
        v-show="clickSwitch"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";
import SingleSelect from "@/views/RecursosPropriosQuestionarios/shared/Singleselect.vue";

import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    SingleSelect,
    Multiselect
  },
  data() {
    return {
      payload: {
        tipoServico: "Centro de Diagnóstico",
        tipoServicoEspecialidade: [],
        tipoServicoPublico: [],
        outro: ""
      },
      listaExames: [],
      outrosOpcao: false
    };
  },
  beforeMount() {
    this.inicializarExames();
  },
  methods: {
    inicializarExames() {
      return this.getEspecialidades(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaExames = [...data];
        }
      });
    }
  },

  watch: {
    // "payload.tipoServicoEspecialidade": "checkEspecialidades",
    "payload.outro": "emitir",
    "payload.tipoServicoPublico": `emitir`,
    dadosServidor(newVal) {
      if (newVal.especialidades.length > 0) {
        newVal.especialidades.forEach(especialidade => {
          if (
            especialidade.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidade",
              especialidade.tipoServicoEspecialidade
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (
            servico.tipoServico.tipoServico === this.payload.tipoServico &&
            (servico.tipoServicoPublico || servico.outro)
          ) {
            this.clickSwitch = true;
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.preencheCampo("outro", servico.outro);
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    }
  }
};
</script>
